<template>
  <span :style="customStyle.style" :class="customStyle.classArr" @click.stop="handleJump">
    {{ content }}
  </span>
</template>

<script>
const defaultType = ['bold', 'italic', 'underline', 'link'];

export default {
  components: {
    // 'render-title':
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    customStyle(){
      let style = {};
      let classArr = [];

      if (this.config.marks && this.config.marks.length){
        this.config.marks.forEach(item => {
          if (!defaultType.includes(item.type)){
            style = Object.assign(style, item.attrs);
          } else {
            classArr.push(item.type);
          }
        });
      }
      if (this.config.type === 'hashtag' || this.config.type === 'mention'){
        classArr.push(this.config.type);
      }
      return {style, classArr};
    },
    linkConf(){
      let conf = {};

      if (this.config.marks && this.config.marks.length){
        this.config.marks.forEach(item => {
          if (item.type === 'link' && item.attrs){
            conf = item.attrs;
          }
        });
      }
      return conf;
    },
    content(){
      let content = this.config.text;

      if (this.config.type === 'hashtag' || this.config.type === 'mention'){
        let item = this.config.content || [];

        content = item[0].text;
      }
      return content;
    }
  },
  mounted(){
  },
  methods: {
    handleJump(){
      if (this.config.type === 'hashtag' || this.config.type === 'mention'){
        const attr = this.config.attrs || {};

        attr.text = this.content;
        this.$emit(`${this.config.type}-click`, attr);
        return ;
      }
      if (this.linkConf.href){
        this.$emit('link-click', this.linkConf.href, this.config);
        return;
      }
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/standard';

.bold {
  // font-weight: $bold;
  @include blue_sky_bold;
}

.italic {
  font-style: italic;
}

.hashtag,
.mention,
.link {
  color: $color_bs1_front;
}

.underline {
  text-decoration: underline;
}
</style>